import { FormRowModule } from './../form-row/form-row.module';
import { SubIndustriesComponent } from './sub-industries.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module';

@NgModule({
    declarations: [
        SubIndustriesComponent
    ],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormRowModule,
        TranslateModule,
        ContentEditableModule
    ],
    exports: [
        SubIndustriesComponent
    ]
})

export class SubIndustriesModule { }
